var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GatewaySettings',{attrs:{"gateway-name":"signal","display-name":"Signal"}},[_c('SignalInstructions',{attrs:{"slot":"instructions"},slot:"instructions"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }